import * as z from "zod";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum TagsFilterQuery {
  CONTAINS = "contains",
  NOT_CONTAINS = "notContains",
}

const TagsFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.TAGS,
  TagsFilterQuery,
  z.array(z.string()),
);
export const TagsFilterSchema: z.ZodType<TagsFilter> = TagsFilterSchema_;
export interface TagsFilter extends z.infer<typeof TagsFilterSchema_> {}
